import { useQuery } from '@tanstack/react-query';

import { api } from 'utils/axios';
import useUrlParams from 'utils/urlParms';

const GET_AGENCY_AGREEMENT_QUERY = 'get-agency-agreement';

const getAgencyAgreement = async (params) => {
  try {
    const response = await api.get(`/agreement`, { params });
    return response.data;
  } catch (e) {
    console.error(e, 'Error fetching agency agreement');
  }

};

const useGetAgencyAgreement = () => {
  const { getUrlParams } = useUrlParams();
  const params = getUrlParams();

  return useQuery({
    queryKey: [GET_AGENCY_AGREEMENT_QUERY, params],

    queryFn: () => getAgencyAgreement(params),
  });
};

export { useGetAgencyAgreement, GET_AGENCY_AGREEMENT_QUERY };
